import api from "../index";

// Validate appsumo select user
export const validateAppSumoSelectUser = async (email: any) => {
  return await api.post("/appsumo/select/validate", { email });
};

// Get last action of appsumo select user
export const getLastActionOfSelectUser = async (email: any) => {
  return await api.get(`/appsumo/select/last-action/${email}`);
};
